export class AlarmaLeve {
  id: number;
  nombre: string;

  constructor(id: number, nombre: string) {
    this.id = id;
    this.nombre = nombre;
    this.nombre = nombre;
  }
}
